import {useEffect} from "react";
import { Switch, Form, Input, Flex, Button, InputNumber, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";


const sortOptions = [
  { label: "Ascending", value: "ascending" },
  { label: "Descending", value: "descending" },
];

const MultipleChoiceForm = ({ formValues, form }) => {
  const { t } = useTranslation();

  const optionsCount = (formValues?.options || []).length;

  useEffect(() => {
    if (
      formValues?.enableScoring &&
      form.getFieldValue("maxSelectableOptions") == null
    ) {
      form.setFieldsValue({ maxSelectableOptions: optionsCount });
    }
  }, [formValues?.enableScoring, optionsCount, form]);


  // Function to trigger component re-render

  return (
    <>
      <Form.Item name="label" label={t("Label")}>
        <Input placeholder={t("Enter label")} />
      </Form.Item>
      <Form.Item
        name="tooltip"
        label={t("Tooltip")}
        className="horizontal-form-item"
      >
        <Switch size="small" />
      </Form.Item>
      {formValues && formValues.tooltip && (
        <Form.Item label="" name="helpText">
          <TextArea rows={2} placeholder={t("Enter help text")} />
        </Form.Item>
      )}
      <Form.Item
        name="mandatory"
        label={t("Mandatory")}
        className="horizontal-form-item"
      >
        <Switch size="small" />
      </Form.Item>
      <Form.Item
        name="readOnly"
        label={t("Read Only")}
        className="horizontal-form-item"
      >
        <Switch size="small" />
      </Form.Item>
      <Form.Item
        name="hideInitially"
        label={t("Hide Initially")}
        className="horizontal-form-item"
      >
        <Switch size="small" />
      </Form.Item>
      <Form.Item name="layout" label={t("Vertical")} className="horizontal-form-item">
        <Switch size="small" />
      </Form.Item>

      <Form.Item
        name="highlight"
        label={t("Highlight")}
        className="horizontal-form-item"
      >
        <Switch size="small" />
      </Form.Item>

      <Form.Item name="enableScoring" label={t("Enable Scoring")} className="horizontal-form-item">
        <Switch size="small" />
      </Form.Item>
      {formValues?.enableScoring && (
        <Form.Item
          name="maxSelectableOptions"
          label={t("Max Options to be selected")}
        >
          <InputNumber
            min={1}
            max={(formValues?.options || []).length || undefined}
            style={{ width: "100%" }}
            placeholder={t("Enter max options to be selected")}
          />
        </Form.Item>
      )}

      

      <div style={{ marginBottom: "12px" }}>{t("List options")}</div>{" "}
      <Form.List name="options">
        {(fields, { add, remove }) => {
          const validateUniqueOption = (_, value) => {
            if (!value || !value.trim()) {
              return Promise.resolve();
            }

            const currentValues = form.getFieldsValue();
            const options = currentValues.options || [];
            const trimmedValue = value.toLowerCase().trim();

            // Count how many times this value appears
            const count = options.filter(opt =>
              opt && opt.label && opt.label.toLowerCase().trim() === trimmedValue
            ).length;

            if (count > 1) {
              setTimeout(() => {
                remove(options.length - 1)
              }, [2000])
              return Promise.reject(new Error("Option already exists"));
            }

            return Promise.resolve();
          };

          return (
            <>

              {fields.map((key, name, ...restField) => (
                <Flex gap={12} justify="space-between" key={key}>
                  <Form.Item
                    name={[name, "label"]}
                    style={{ marginBottom: "20px", width: "100%" }}
                    rules={[
                      { required: true, whitespace: true, message: t("Option is required") },
                      { validator: validateUniqueOption },
                    ]}
                  >
                    <Input
                      placeholder={t("Enter option")}
                      suffix={
                        <DeleteOutlined
                          style={{ color: "red", cursor: "pointer" }}
                          onClick={() => {
                            remove(name);// Trigger update after removal
                          }}
                        />
                      }
                    />
                  </Form.Item>
                  <Form.Item name={[name, "value"]}>
                    <Input hidden />
                  </Form.Item>
                </Flex>
              ))}                  <Form.Item>
                <Flex gap={8}>
                  <Button
                    className="success-button"
                    onClick={() => add({ label: "", value: uuidv4() })}
                    icon={<PlusOutlined />}
                  >{t("Add")}</Button>
                </Flex>
              </Form.Item>
            </>
          );
        }}
      </Form.List>
      <Form.Item name="sort" label={t("Sort")}>
        <Select options={sortOptions.map((option) => ({ label: t(option.label), value: option.value }))} allowClear />
      </Form.Item>
    </>
  );
};

export default MultipleChoiceForm;
